import { URLS } from "../../_config";
import { replaceUrlParams, showDate } from "../../_common/functions";
import { Link } from "react-router-dom";

const BottomNewsList = ({ newsList, title = 'More News' }: any) => {
    return (
        <div className="mt-5"> 
            <div className="banner-text latest_news_title">
                <h2 data-aos="fade-up" className="text-left pb-1">{title} </h2>
            </div>
            <div className="row">
                <div className="col-lg-12 col-md-12">
                    <div className="row">
                        {
                            newsList?.length === 0 && <div className="text-left">No News Found</div>
                        }
                        {
                            newsList === null && <div className="text-center my-5">Loading...</div>
                        }
                        {
                            newsList?.map((item: any, index: number) => {
                                return <div key={`BottomNewsList__${index}`} className="col-lg-3 col-md-3 col-sm-6">
                                    <div className="news_liatitem">
                                        <div className="news_listimage">
                                            <Link to={replaceUrlParams(URLS.BLOG_NEWS.NEWS_DETAILS, { slug: item?.slug })}>
                                                <img src={item?.latest_news_thumb?.original} alt={item?.title} />
                                            </Link>
                                            <div className="news_date">
                                                <span className="news_datetxt">{showDate(item?.published_date, 'DD')}</span>
                                                <span className="news_datemonth">{showDate(item?.published_date, 'MMM')}</span>
                                            </div>
                                        </div>
                                        <Link to={replaceUrlParams(URLS.BLOG_NEWS.NEWS_DETAILS, { slug: item?.slug })}>
                                            <h3 className="news_title">{item?.title}</h3>
                                        </Link>
                                        <p>{item?.short_description}</p>
                                        <div className="more_btn">
                                            <Link to={replaceUrlParams(URLS.BLOG_NEWS.NEWS_DETAILS, { slug: item?.slug })}>Read More</Link>
                                        </div>
                                    </div>
                                </div>
                            })

                        }

                    </div>
                </div>

            </div>
        </div>
    );
}
export default BottomNewsList;